import { apiSlice } from "../createApiSlice";

const API_BASE = "/general";
const buildUrl = (endpoint) => API_BASE + endpoint;

export const generalApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getEnums: builder.query({
            query: (filterParams) => ({
                url: buildUrl(`/enums${filterParams ? `?filter=${filterParams}` : ""}`),
                method: 'GET',
            }),
        }),
        lookupDutchAddress: builder.query({
            query: ({ postalCode, houseNumber }) => ({
                url: buildUrl(`/address-lookup?postalCode=${encodeURIComponent(postalCode)}&houseNumber=${encodeURIComponent(houseNumber)}`),
                method: 'GET',
            }),
        }),
        getSettings: builder.query({
            query: (key) => ({
                url: buildUrl(`/settings/${key}`),
                method: 'GET',
            }),
            providesTags: (result, error, key) => [{ type: 'Settings', key }],
        }),
        updateSetting: builder.mutation({
            query: (setting) => ({
                url: buildUrl(`/setting`),
                method: 'PUT',
                body: setting,
            }),
            invalidatesTags: (result, error, setting) => [{ type: 'Settings', key: setting.key.split('_')[0] }, { type: 'Onboarding' }],
        }),
        getSettingsForRelation: builder.query({
            query: (relationId) => ({
                url: buildUrl(`/relationsettings/${relationId}`),
                method: 'GET'
            }),
            providesTags: (result, error, key) => [{ type: 'RelationSettings'}],
        }),
        getSettingsForRelationRaw: builder.query({
            query: (relationId) => ({
                url: buildUrl(`/relationsettingsraw/${relationId}`),
                method: 'GET'
            }),
            providesTags: (result, error, key) => [{ type: 'RelationSettingsRaw'}],
        }),
        updateSettingForRelation: builder.mutation({
            query: (setting) => ({
                url: buildUrl(`/relationsetting`),
                method: 'PUT',
                body: setting,
            }),
            invalidatesTags: (result, error, setting) => [{ type: 'RelationSettings'}, { type: 'RelationSettingsRaw'}, { type: 'Onboarding' }],
        }),
        updateSettingsForRelation: builder.mutation({
            query: (settings) => ({
                url: buildUrl(`/relationsettings`),
                method: 'PUT',
                body: settings,
            }),
            invalidatesTags: (result, error, setting) => [{ type: 'RelationSettings'}, { type: 'RelationSettingsRaw'}],
        }),
    })
});

export const { 
    useGetEnumsQuery,
    useGetSettingsQuery,
    useUpdateSettingMutation,
    useGetSettingsForRelationQuery,
    useUpdateSettingForRelationMutation,
    useGetSettingsForRelationRawQuery,
    useUpdateSettingsForRelationMutation,
    useLazyLookupDutchAddressQuery
} = generalApiSlice;
